// extracted by mini-css-extract-plugin
export default {"featuredGrid":"Playground-module__featuredGrid__uHJknL1"};